"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Projects = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxConnect = require("redux-connect");

var _reactRouter = require("react-router");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _projects = require("../../redux/modules/projects");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Projects = exports.Projects = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Projects, _Component);

  function Projects(props) {
    (0, _classCallCheck3.default)(this, Projects);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Projects.__proto__ || (0, _getPrototypeOf2.default)(Projects)).call(this, props));

    _this.state = {
      activeProjects: true,
      closedProjects: false
    };

    _this.handleInputChange = _this.handleInputChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Projects, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isProjectsLoaded = this.props.isProjectsLoaded;

      if (!isProjectsLoaded) {
        (0, _projects.loadProjects)();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === "checkbox" ? target.checked : target.value;
      var name = target.name;

      this.setState((0, _defineProperty3.default)({}, name, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          user = _props.user,
          company = _props.company;


      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Projektit" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              company.name,
              ": Projektit"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            "Y-tunnus : ",
            company.business_id,
            " ",
            _react2.default.createElement("br", null),
            "Yritys : ",
            company.name,
            " ",
            _react2.default.createElement("br", null),
            "Nimi : ",
            user.first_name,
            " ",
            user.last_name,
            " ",
            _react2.default.createElement("br", null),
            "Puhelinnumero : ",
            user.phone,
            " ",
            _react2.default.createElement("br", null),
            "S\xE4hk\xF6posti: ",
            user.email,
            " ",
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Button2.default, {
              text: "Luo uusi Projekti",
              additionalClasses: "button-set-width",
              onClick: this.handleCreateProjectButtonClick.bind(this)
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Projektit"
            ),
            _react2.default.createElement(
              "div",
              { className: "checkbox-single" },
              _react2.default.createElement(
                "label",
                null,
                "Aktiiviset:",
                _react2.default.createElement("input", {
                  name: "activeProjects",
                  type: "checkbox",
                  checked: this.state.activeProjects,
                  onChange: this.handleInputChange
                })
              ),
              _react2.default.createElement(
                "label",
                null,
                "Ei Aktiiviset:",
                _react2.default.createElement("input", {
                  name: "closedProjects",
                  type: "checkbox",
                  checked: this.state.closedProjects,
                  onChange: this.handleInputChange
                })
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "basic-list" },
              _react2.default.createElement(
                "table",
                null,
                _react2.default.createElement(
                  "thead",
                  null,
                  _react2.default.createElement(
                    "tr",
                    null,
                    _react2.default.createElement(
                      "th",
                      null,
                      "Projektin nimi:"
                    ),
                    _react2.default.createElement(
                      "th",
                      null,
                      "Kuvaus:"
                    ),
                    _react2.default.createElement(
                      "th",
                      null,
                      "Ty\xF6numero:"
                    ),
                    _react2.default.createElement(
                      "th",
                      null,
                      "Muokkaa projektia"
                    )
                  )
                ),
                _react2.default.createElement(
                  "tbody",
                  null,
                  this.renderProjects(this.state.activeProjects, this.state.closedProjects)
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderProjects",
    value: function renderProjects(activeProjects, closedProjects) {
      var _this2 = this;

      //   console.info('this.props.project', this.props.projects);
      if (!this.props.projects) {
        return _react2.default.createElement(
          "tr",
          { className: "voucher-row-js" },
          _react2.default.createElement(
            "td",
            null,
            "EI Projekteja"
          ),
          _react2.default.createElement("td", { className: "hidden-mobile" }),
          _react2.default.createElement("td", null),
          _react2.default.createElement("td", null)
        );
      }

      return this.props.projects.map(function (proj, index) {
        console.info("activeProjects", activeProjects);

        if (activeProjects == true && proj.active == true) {
          return _react2.default.createElement(
            "tr",
            { key: index },
            _react2.default.createElement(
              "td",
              { style: { width: "20%" } },
              " ",
              proj.name,
              " "
            ),
            _react2.default.createElement(
              "td",
              {
                style: {
                  height: "auto",
                  wordWrap: "normal",
                  maxWidth: "40%",
                  flex: 1,
                  flexWrap: "wrap"
                }
              },
              proj.project_description
            ),
            _react2.default.createElement(
              "td",
              { style: { width: "20%" } },
              proj.construction_site_id
            ),
            _react2.default.createElement(
              "td",
              { style: { width: "20%" } },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: _this2.createLink(proj) },
                "Siirry projektiin ",
                proj.id
              )
            )
          );
        }

        if (closedProjects == true && proj.active == false) {
          return _react2.default.createElement(
            "tr",
            { className: "voucher-row-js", key: index },
            _react2.default.createElement(
              "td",
              null,
              " ",
              proj.name,
              " "
            ),
            _react2.default.createElement(
              "td",
              null,
              " ",
              proj.project_description,
              " "
            ),
            _react2.default.createElement(
              "td",
              { className: "hidden-mobile" },
              proj.construction_site_id
            ),
            _react2.default.createElement(
              "td",
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: _this2.createLink(proj) },
                "SULJETTU Siirry projektiin ",
                proj.id
              )
            )
          );
        }
      });
    }
  }, {
    key: "handleCreateProjectButtonClick",
    value: function handleCreateProjectButtonClick() {
      this.props.pushRoute("/uusi-projekti");
      /*
      this.props.resetState();   
      if (this.props.supplierAd) {
        this.props.pushRoute('/ilmoitukset/vastaanotettavat');
      } else {
        this.props.pushRoute('/ilmoitukset/tarjottavat');
      }
      */
    }
  }, {
    key: "createLink",
    value: function createLink(singleProject) {
      var params = this.props.params; // use this later when token needs

      if (params.token) {
        return "/projekti/" + params.token + "/" + singleProject.id + " ";
      }
      return "/projekti/" + singleProject.id + " ";
    }
  }]);
  return Projects;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  company: _react.PropTypes.object,
  projects: _react.PropTypes.array.isRequired,
  loadProjects: _react.PropTypes.func,
  isProjectsLoaded: _react.PropTypes.func
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        user = _ref$store.user;

    var promises = [];
    // here vi load projects
    // pass promised to dispatch
    //  if (!isProjectsLoaded(getState())) {
    promises.push(dispatch((0, _projects.loadProjects)()));
    //  }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(
// State map
function (state) {
  return {
    projects: state.projects.projects,
    user: state.auth.user,
    company: state.company.company
  };
},
// Dispatch map
{
  pushRoute: _reactRouterRedux.push
})(Projects));

/** connet (mapStateToProps, mapDispatchToProps) */


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Projects/Projects.js
 ** module id = 1236
 ** module chunks = 0
 **/